import { useEffect, useRef, useCallback } from 'preact/hooks';

/**
 * 返回当前最新值的 Hook，可以避免闭包问题
 * @param value
 * @returns {React.MutableRefObject<*>}
 */
export function useLatest(value) {
  const ref = useRef(value);
  ref.current = value;

  return ref;
}

/**
 * 一个可以处理 setInterval 的 Hook
 * @param fn
 * @param delay  间隔时间，当取值 null 时会停止计时器
 * @param options immediate 是否在首次渲染时立即执行 默认false
 * @returns fn 清除定时器
 */
export function useInterval(fn, delay, options) {
  const immediate = options?.immediate;
  const fnRef = useLatest(fn);
  const timerRef = useRef();

  useEffect(() => {
    if (typeof delay !== 'number' || delay < 0) return;
    if (immediate) {
      fnRef.current();
    }
    timerRef.current = setInterval(() => {
      fnRef.current();
    }, delay);
    return () => {
      if (timerRef.current) {
        clearInterval(timerRef.current);
      }
    };
  }, [delay]);

  const clear = useCallback(() => {
    if (timerRef.current) {
      clearInterval(timerRef.current);
    }
  }, []);
  return clear;
}
